<iframe *ngIf="iframe" [src]="iframe" width="100%"></iframe>